import { consoleUrl } from '../../../utils';

const CONSOLE_CREATE_TICKET_URL = `${consoleUrl}/us1/support/submit-ticket?frameUrl=/console/support/tickets/create`;
const LOG_PREFIX = '[Contact Support Callout]';

const constants = {
  CONSOLE_CREATE_TICKET_URL,
  LOG_PREFIX,
};

export default constants;
